/**
 * O cabeçalho que só existe no papel do Dashboard.
 *
 * Papel: reproduz `.print-header` (l. 425–452, 502–513): à esquerda o
 * monograma, o filete, o wordmark e "Acompanhamento de Manutenções Corretivas"
 * em latão; à direita a caixa "Gerado em" com a data, de borda de cima latão.
 *
 * Como usar: a `AbaDashboard` o põe acima da faixa e escreve `geradoEm` no
 * clique de "Exportar PDF", antes de imprimir. Na tela ele não aparece; no papel
 * só aparece com a marca `imprimindo-dashboard-de-manutencoes` no `<body>` — um
 * Ctrl+P comum não o mostra. Os dois logotipos são os da `BarraDoApp`, extraídos
 * da origem para `public/marca/`; trocar o arquivo lá exigirá trocar aqui também.
 */

/** Monograma da origem, o mesmo da `BarraDoApp`. */
const MONOGRAMA = '/marca/villa-prado-monograma-origem.jpg';

/** Wordmark da origem, o mesmo da `BarraDoApp`. */
const WORDMARK = '/marca/villa-prado-wordmark-origem.png';

/**
 * O cabeçalho do papel.
 *
 * @param geradoEm - A data de hoje em `dd/mm/aaaa`, em hora local.
 * @returns O cabeçalho, escondido fora da impressão do Dashboard.
 */
export function CabecalhoDeImpressao({ geradoEm }: { geradoEm: string }) {
  return (
    <div className="hidden print:[body[data-impressao=imprimindo-dashboard-de-manutencoes]_&]:mb-3.5 print:[body[data-impressao=imprimindo-dashboard-de-manutencoes]_&]:flex print:[body[data-impressao=imprimindo-dashboard-de-manutencoes]_&]:items-center print:[body[data-impressao=imprimindo-dashboard-de-manutencoes]_&]:justify-between print:[body[data-impressao=imprimindo-dashboard-de-manutencoes]_&]:border-b print:[body[data-impressao=imprimindo-dashboard-de-manutencoes]_&]:border-emb-borda print:[body[data-impressao=imprimindo-dashboard-de-manutencoes]_&]:pb-3">
      <div className="flex items-center gap-3">
        <img
          src={MONOGRAMA}
          alt="Villa Prado"
          className="h-10 w-auto shrink-0 rounded-[3px] object-contain"
        />
        <div aria-hidden="true" className="h-7 w-px shrink-0 bg-emb-borda" />
        <img src={WORDMARK} alt="Villa Prado" className="h-6 w-auto object-contain" />
        <div className="ml-1.5 font-outfit text-[11px] font-normal tracking-[0.08em] text-brass uppercase">
          Acompanhamento de Manutenções Corretivas
        </div>
      </div>
      <div className="rounded-[6px] border border-t-[3px] border-emb-borda border-t-brass bg-superficie px-[18px] py-2 text-center">
        <div className="mb-1 font-mono text-[9px] tracking-[0.7px] text-texto-fraco uppercase">
          Gerado em
        </div>
        <div className="font-outfit text-[17px] font-light tracking-[0.5px] text-foreground">
          {geradoEm}
        </div>
      </div>
    </div>
  );
}
